<div class="modal-header">
    <h4 class="modal-title" id="modalEditNotifTitle">Código de verificación</h4>
   
</div>
<div class="modal-body modal-notif">
    <div class="row mt-2">
        <p>Se requiere un código de verificación para ingresar, este fue enviado a su correo electrónico.</p>
       <mat-form-field class="col-sm-12" appearance="outline">
           <mat-label>Código de verificación</mat-label>
           <input #codeInput matInput placeholder="12345" maxlength="5" name="code" [(ngModel)]="formUser.mfa_code" required>
       </mat-form-field>
    </div>
</div>
<div class="modal-footer">
     <button mat-flat-button class="bg-primary text-white" style="margin-right: 10px;" (click)="resendCode()" type="button" [disabled]="isResendDisabled" [style.opacity]="isResendDisabled ? 0.5 : 1">
        Nuevo código 
        <span *ngIf="isResendDisabled">({{ countdownDisplay }})</span>
    </button>
    <button mat-flat-button [disabled]="formUser.mfa_code.length != 5"  class="bg-success text-white" (click)="ruSure();" type="submit" 
    [style.opacity]="formUser.mfa_code.length != 5 ? 0.5 : 1">Enviar <mat-icon>send</mat-icon></button>
</div>